export function setElementRequired(element: Element, required = false) {
  if (required) {
    element.setAttribute("required", "");
  } else {
    element.removeAttribute("required");
  }
}
